import { Box, IconButton, useTheme, Typography } from "@mui/material";
import { tokens } from "../../theme";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import * as React from "react";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Divider from "@mui/material/Divider";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { removeAuth } from "../../state/authReducer";
import { jwtDecode } from "jwt-decode";

// const user = localStorage.getItem('token');

const Topbar = () => {
  const[cookie,setCookie,removeCookie] = useCookies(["token"])
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const logout = () => {
    removeCookie("token")
    dispatch(removeAuth())
    navigate("/login")
  };
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [cookies] = useCookies(['token']);
  const decodedToken = jwtDecode(cookies['token'])
    const jsonData = JSON.parse(decodedToken.userInfo)
  ///account page
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <Box
      style={{ position: "sticky", top: 0, }}
      display="flex"
      justifyContent="space-between"
      p={2}
      backgroundColor="#ffffff"
      zIndex="999"
    >
      {/* SEARCH BAR */}
      <Box display="flex" borderRadius="3px">
        <Typography fontWeight="bold" variant="h2" color={colors.zamzamBrandGrey[500]}>
        ZamZam Online
        </Typography>
      </Box>

      {/* ICONS */}
      <Box display="flex">
        <IconButton>  
         <Typography variant="h5" fontWeight="bold" color={colors.zamzamBrandGrey[400]}>
        {jsonData.companies.name}
      </Typography>
        </IconButton>
        <Box>
          <IconButton
            ref={anchorRef}
            id="composition-button"
            aria-controls={open ? "composition-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
          >
            {" "}
            <PersonOutlinedIcon style={{ color: "#000000" }} />
          </IconButton>
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            placement="bottom-start"
            transition
            disablePortal={false}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom-start" ? "left top" : "left bottom",
                }}
              >
                <Paper style={{ backgroundColor: "#ffffff" }}>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="composition-menu"
                      aria-labelledby="composition-button"
                      onKeyDown={handleListKeyDown}
                    >
                      <MenuItem
                        onClick={handleClose}
                        style={{ color: "#000000" }}
                      >
                         {jsonData.full_name}
                      </MenuItem>
                      <MenuItem
                        onClick={handleClose}
                        style={{ color: "#000000" }}
                      >
                        My profile
                      </MenuItem>
                      <Divider style={{ backgroundColor: "#000000" }} />
                      <MenuItem onClick={logout} style={{ color: "#000000" }}>
                        Logout
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Box>
      </Box>
    </Box>
  );
};

export default Topbar;
